
<template>
  <div class="master-section">
    <!-- Banner -->
    <div v-if="props.data.length" class="banner">
      <img 
        class="banner-pc img-fluid  alt-lazy-img"
        :src="props.data[activeTab].tab_banner.url" 
        :data-original_src="props.data[activeTab].tab_banner.url ?? ''"
        alt="Banner" 
      />
      <img 
        class="banner-mb img-fluid alt-lazy-img"
        :src="props.data[activeTab].tab_banner.url" 
        :data-original_src="props.data[activeTab].tab_banner_mb.url ?? ''"
        alt="Banner" 
      />
    </div>
    <!-- Tabs -->
    <div class="tabs">
      <template v-for="(tab, index) in props.data" :key="index">
        <button 
          :class="{ active: index === activeTab }"
          @click="activeTab = index"
        >
          {{ tab.tab_title }}
        </button>
        <!-- Add separator except after the last button -->
        <span v-if="index !== props.data.length - 1"> | </span>
      </template>
    </div>

    <!-- Product Grid -->
    <div v-if="props.data.length" class="product-grid col-12">
      <!-- <ItemCrouselLayout v-if="props.data.length" :data="props.data[0]" :data_item="filteredProducts"></ItemCrouselLayout> -->
      <template v-for="( item, item_id) in filteredProducts" :key="item_id">
          <ListingItem :item = item ></ListingItem>
      </template >
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, defineProps } from 'vue';
import ItemCrouselLayout from "../TemplateMaster/ItemCrouselLayout.vue";
import ListingItem from "~/components/Product/ProductItem.vue";

interface Product {
  id: number;
  title: string;
  image: string;
  price: string;
  link: string;
}

interface TabData {
  product_section_id: any;
  tab_title: string;
  format_session: string;
  select_postytype: string;
  tab_banner: any;
  tab_banner_mb: any;
  select_products: Product[];
}

// const props = defineProps<{ data: TabData[] , data_item:any }>();
const props = defineProps<{ data: TabData[]; data_item: any }>();
const activeTab = ref(0);;

// Filter products based on activeTab's product_section_id
const filteredProducts = computed(() => {
  if (!props.data || props.data.length === 0) return [];

  const sectionId = props.data[activeTab.value]?.product_section_id;
  console.log('Tab ID:', sectionId);
  console.log('Available product keys:', Object.keys(props.data_item || {}));

  if (!sectionId) return [];

  const products = props.data_item?.[sectionId] || [];
  console.log('Filtered Products:', products);

  return products;
});
watch(activeTab, () => {
  initLazyLoad();
});
const initLazyLoad = () => {
  nextTick(() => {
    const elements = document.querySelectorAll('.alt-lazy-img'); // Update selector if needed
    if (elements.length > 0) {
      altLazyIO();
    }
  });
};
onMounted(() => {
    altLazyIO()
    window.addEventListener("resize", altLazyIO);
});

</script>

<style lang="scss">
 @import "@/assets/scss/components/master-template/_master-tabtoggle.scss";
</style>
